// extracted by mini-css-extract-plugin
export default {"capitalize":"_5aMGS"};